var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './framework/Timeouts';
export class Dten {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.commandCodes = {
            // Trailing \xAA is added with sendTerminator
            pc: '\xFE\x60\x00\x24\x00',
            vga: '\xFE\x60\x00\x21\x00',
            hdmi1: '\xFE\x60\x00\x23\x00',
            hdmi2: '\xFE\x60\x00\x43\x00',
            dp: '\xFE\x60\x00\x63\x00',
            volumeUp: '\x99\x01\x17\x01\xE8',
            volumeDown: '\x99\x01\x18\x01\xE7',
            mute: '\x99\x01\x02\x01\xFD',
            unMute: '\x99\x01\x02\x01\xFD',
            powerOn: '\x99\xA2\x01\x01\x27\xAA\xAA',
            powerOff: '\x99\x01\x05\x01\xFA',
        };
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.sendAsync(this.commandCodes[`${power ? 'powerOn' : 'powerOff'}`], tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                return power;
            }),
            isStateless: true,
        };
        this.videoInput = {
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.sendAsync(this.commandCodes[code], tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return code;
            }),
            isStateless: true,
        };
    }
    // polling
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return 'connected';
        });
    }
}
// static properties
Dten.driverType = 'socketDriver';
Dten.key = '-MOY0lfM8MXbwgItR7pc';
Dten.baseSocketOptions = {
    commandExtractor: {
        terminators: [],
    },
    sendTerminator: '\xAA',
    isBinary: true,
    idleTimeoutMs: 0,
};
Dten.socketOptions = [
    Object.assign(Object.assign({}, Dten.baseSocketOptions), { port: 4999 }),
];
